if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // UI Feedback: Start Loading
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // --- 1. CONFIGURATION & DATA ---
        const handlingFeeId = 43157664923732; 
        const formData = new FormData(this.form);
        const mainVariantId = Number(formData.get('id'));
        const mainQty = Number(formData.get('quantity') || 1);
        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        try {
          // --- 2. CHECK IF HANDLING FEE IS ALREADY IN CART ---
          const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
          const currentCart = await cartResponse.json();
          
          const hasHandlingFee = currentCart.items.some(item => item.variant_id === handlingFeeId);

          // --- 3. CONSTRUCT THE ITEMS ARRAY ---
          const itemsToAdd = [
            { id: mainVariantId, quantity: mainQty }
          ];

          // Only push the handling fee if it's missing from the cart
          if (!hasHandlingFee) {
            itemsToAdd.push({ id: handlingFeeId, quantity: 1 });
          }

          // --- 4. POST TO SHOPIFY CART ---
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' 
            },
            body: JSON.stringify({
              items: itemsToAdd,
              sections: sections,
              sections_url: window.location.pathname
            })
          });

          const responseData = await response.json();

          // --- 5. HANDLE RESPONSE ---
          if (responseData.status) {
            // Logic for errors (e.g., Sold Out)
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainVariantId,
              errors: responseData.errors || responseData.description,
              message: responseData.message,
            });
            this.handleErrorMessage(responseData.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
            }
            return;
          }

          this.error = false;

          // Update Theme Drawer/Notification
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const startMarker = CartPerformance?.createStartingMarker('add:wait-for-subscribers');
          
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainVariantId,
            cartData: responseData,
          }).then(() => {
            if (startMarker) CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            
            // Force open drawer if standard publish doesn't trigger it
            if (this.cart && typeof this.cart.open === 'function') {
              this.cart.open();
            }
          });

          // Render updated sections in the drawer
          if (CartPerformance && typeof CartPerformance.measure === 'function') {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(responseData);
            });
          } else {
            this.cart.renderContents(responseData);
          }

          // Close Quick Add modal if applicable
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) quickAddModal.hide(true);

        } catch (error) {
          console.error("Product Form Error:", error);
          this.handleErrorMessage("An unexpected error occurred. Please try again.");
        } finally {
          // UI Feedback: Stop Loading
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) { this.errorMessage.textContent = errorMessage; }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}